import { singleBrandUrlRegex } from '../../../../shared/constants/single-brand-ulr-regex'
import { useFullUrl } from '../../../../shared/hooks/useFullUrl'
import { regexValidator } from '../../../../shared/utils/regex-validator'

export const useFilterQueryParams = function useFilterQueryParams() {
  const { getFullUrl } = useFullUrl()

  return {
    getFilterQueryParams() {
      let fullUrl = getFullUrl()
      const singleBrandUrlParts = fullUrl.match(singleBrandUrlRegex)

      if (singleBrandUrlParts) {
        const [singleBrand, manufacturerName] = singleBrandUrlParts
        fullUrl = fullUrl.replace(
          singleBrand,
          `filters.manufacturers.manufacturer=${manufacturerName}`
        )
      }

      const basicFilterParams = fullUrl.match(regexValidator.getBasicFilterQueryParams)
      const needsBasedFilterParams = fullUrl.match(regexValidator.getNbfFilterQueryParams)
      const filterCategory = fullUrl.match(regexValidator.getFilterCategory)

      return {
        basicFilterParams,
        needsBasedFilterParams,
        filterCategory,
      }
    },
  }
}
